import { z } from "zod";

const schema = z
  .object({
    EXPO_PUBLIC_SENTRY_DSN: z.string().optional(),
    EXPO_PUBLIC_SENTRY_ENVIRONMENT: z.string().optional(),

    EXPO_PUBLIC_GA_MEASUREMENT_ID: z.string().optional(),

    EXPO_PUBLIC_CLEENG_PUBLISHER_ID: z.string(),
    EXPO_PUBLIC_CLEENG_CURRENCY: z.string(),
    EXPO_PUBLIC_CLEENG_COUNTRY: z.string(),
    EXPO_PUBLIC_CLEENG_ENVIRONMENT: z.enum(["production", "sandbox"]),

    EXPO_PUBLIC_HYVIEW_GRAPHQL_ENDPOINT: z.url(),
  })
  .transform((value) => ({
    SENTRY_DSN: value.EXPO_PUBLIC_SENTRY_DSN,
    SENTRY_ENVIRONMENT: value.EXPO_PUBLIC_SENTRY_ENVIRONMENT,

    GA_MEASUREMENT_ID: value.EXPO_PUBLIC_GA_MEASUREMENT_ID,

    CLEENG_PUBLISHER_ID: Number(value.EXPO_PUBLIC_CLEENG_PUBLISHER_ID),
    CLEENG_CURRENCY: value.EXPO_PUBLIC_CLEENG_CURRENCY,
    CLEENG_COUNTRY: value.EXPO_PUBLIC_CLEENG_COUNTRY,
    CLEENG_ENVIRONMENT: value.EXPO_PUBLIC_CLEENG_ENVIRONMENT,

    HYVIEW_GRAPHQL_ENDPOINT: value.EXPO_PUBLIC_HYVIEW_GRAPHQL_ENDPOINT,
  }));

const env = schema.parse({
  EXPO_PUBLIC_SENTRY_DSN: process.env.EXPO_PUBLIC_SENTRY_DSN,
  EXPO_PUBLIC_SENTRY_ENVIRONMENT: process.env.EXPO_PUBLIC_SENTRY_ENVIRONMENT,

  EXPO_PUBLIC_GA_MEASUREMENT_ID: process.env.EXPO_PUBLIC_GA_MEASUREMENT_ID,

  EXPO_PUBLIC_CLEENG_PUBLISHER_ID: process.env.EXPO_PUBLIC_CLEENG_PUBLISHER_ID,
  EXPO_PUBLIC_CLEENG_CURRENCY: process.env.EXPO_PUBLIC_CLEENG_CURRENCY,
  EXPO_PUBLIC_CLEENG_COUNTRY: process.env.EXPO_PUBLIC_CLEENG_COUNTRY,
  EXPO_PUBLIC_CLEENG_ENVIRONMENT: process.env.EXPO_PUBLIC_CLEENG_ENVIRONMENT,

  EXPO_PUBLIC_HYVIEW_GRAPHQL_ENDPOINT:
    process.env.EXPO_PUBLIC_HYVIEW_GRAPHQL_ENDPOINT,
});

export const {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,

  GA_MEASUREMENT_ID,

  CLEENG_PUBLISHER_ID,
  CLEENG_CURRENCY,
  CLEENG_COUNTRY,
  CLEENG_ENVIRONMENT,

  HYVIEW_GRAPHQL_ENDPOINT,
} = env;
